module.exports = __webpack_public_path__ + "img/9791155640265.13310317.jpg";